//interfaces
interface Props {
    reqId: number;
}

export default function CCTVAdminStolenItems({ reqId }: Props) {
    return <div className="stolen-items-list">CCTVAdminStolenItems</div>;
}
